<template lang="pug">
  .TheHeaderLoginSignupLogic.header-logic(:class="{'not-sign-pages': !isLoginPage && !isSignUpPage}")
    span.captions.small-text(v-show="isSignUpPage") Already have an account?
    span.captions.small-text(v-show="isLoginPage") Don't have an account?
    v-btn(
      v-show="isSignUpPage",
      color="primary",
      :to="{ name: 'sign-in', query: $route.query }",
      replace
      small,
      key="login-button"
    ) Log In
    router-link.link-2(
      v-show="!isSignUpPage && !isLoginPage",
      to="/sign-in",
      key="login-link"
    ) Log In
    v-btn(
      v-show="!isSignUpPage",
      color="primary",
      small,
      :to="{ name: 'sign-up', query: $route.query }",
      replace
      key="signup"
    ) Sign Up
</template>

<script>

export default {
  name: 'TheHeaderLoginSignupLogic',
  props: {
    isLoginPage: Boolean,
    isSignUpPage: Boolean,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.header-logic
  display: flex
  flex-direction: row
  align-items: center
  position: relative
  z-index: 3
  &.not-sign-pages
    @media screen and (max-width: 991px)
      display: none
  .captions
    margin-right: 30px
    @media screen and (max-width: 991px)
      display: none
  .link-2
    margin-right: 30px
    margin-top: 2px
    line-height: 18px
    font-size: 14px
</style>
